import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { SupplierAllocationsUpdate } from '@ps/survey-utils';

import { SupplierActions } from './supplier.actions';

@Injectable({ providedIn: 'root' })
export class SupplierActionsFacade {
  private readonly _store = inject(Store);

  public loadAllocations(surveyId: number): void {
    this._store.dispatch(
      SupplierActions.loadAllocations({ surveyId, params: { scope: 'view' } }),
    );
  }

  public updateAllocations(
    surveyId: number,
    update: SupplierAllocationsUpdate,
  ): void {
    this._store.dispatch(
      SupplierActions.updateAllocations({ surveyId, update }),
    );
  }

  public resetAllocations(): void {
    this._store.dispatch(SupplierActions.resetAllocations());
  }
}
